import { SearchExistingField } from '@skyline-platform/alchemy';
import { SourceForm } from './SourceForm';
import { getSources } from '@utils/graphql/creators/sources';
import PropTypes from 'prop-types';
import { useState } from 'react';
import * as is from 'is';
import { formatSourceData } from './utils';
import { getLogger } from '@utils/general';
import { getStreamProfileLabel } from '@pages/utils/helpers';

const logger = getLogger('src.components.FormComponents.SourceForm.SearchExistingSource');

export const SearchExistingSource = ({ ...props }) => {
  const {
    formData, setFormData, lockDownFields, sourceCategory,
  } = { ...props };
  const [newCreatedSource, setNewCreatedSource] = useState(() => formData || {});

  const editForm = !is.undefined(formData) && !is.empty(formData);
  const formTitle = editForm ? 'Edit' : 'Create New';
  const streamProfLabel = `${sourceCategory || 'Stream'} Profile`;

  const getAvailableSources = async () => {
    // Getting sources only by standard category because we don't want to have
    // users add streams to offline devices. It will break the save functionality.
    // Currently we only have 'Standard' and 'Offline', this check might need to
    // be revisited in the future if more categories are added.
    const { query, execute } = lockDownFields?.device
      ? getSources(null, { deviceId: lockDownFields.device.id, category: 'Standard' })
      : getSources(null, { category: sourceCategory ?? 'Standard' });

    query.addReturnProperties(
      'name',
      'id',
      'description',
      'sdp_input',
      'port',
      'path',
      'scheme',
      'appliance.id',
      'appliance.name',
      'appliance.management_address',
      'device.id',
      'device.name',
      'device.network_address'
    );

    try {
      const res = await execute();
      const normalizedData = res.data.map((source) => {
        return {
          ...source,
          name: getStreamProfileLabel(source),
        };
      });

      return {
        ...res,
        data: normalizedData,
      };
    } catch (error) {
      logger.error(error.message);
    }
  };

  return (
    <SearchExistingField
      fieldName={streamProfLabel}
      modalHeader={`${formTitle} ${streamProfLabel}`}
      required={is.undefined(sourceCategory)}
      showEdit={!is.undefined(sourceCategory)}
      newFieldForm={(handleClose) => (
        <SourceForm
          handleClose={handleClose}
          setSourceData={setFormData}
          sourceData={editForm ? formatSourceData(formData) : undefined}
          setNewCreatedSource={setNewCreatedSource}
          sourceCategory={sourceCategory}
          lockDownFields={lockDownFields}
        />
      )}
      fetchData={getAvailableSources}
      formData={formData}
      newlyCreatedItem={newCreatedSource}
      useWarning={lockDownFields?.device}
      warningMessage={`There are no Stream Profiles attached to the selected camera.
        Please create a new Stream Profile to continue.`}
      {...props}
    />
  );
};

SearchExistingSource.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
  }),
  setFormData: PropTypes.func.isRequired,
  lockDownFields: PropTypes.object,
};
